CNT.ngModule.constant('loginAppO2Constant', {

});
